import React from 'react'

import UserLocationCircle from './UserLocationCircle';
import { GOOGLE_MAPS_JS_API_KEY } from "../config.js";

export default class MapViewer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};

        this.createDynamicGoogleMap = this.createDynamicGoogleMap.bind(this);
        this.handleMapDragEnd = this.handleMapDragEnd.bind(this);
        this.handleMapZoomChanged = this.handleMapZoomChanged.bind(this);
    }

    componentDidMount() {
        //this.createDynamicGoogleMap();
        this.createStaticGoogleMap();
    }

    componentDidUpdate(prevProps, prevState) {

          // Update the center of the map if changed
          if ((this.props.initialCenterLat !== prevProps.initialCenterLat) || (this.props.initialCenterLng !== prevProps.initialCenterLng)) {
            if (this.state.map) {
              const latLng = new google.maps.LatLng(this.props.initialCenterLat, this.props.initialCenterLng);
              this.state.map.setCenter(latLng);
            } else {
                this.createStaticGoogleMap();
            }
          }

          // Update the zoom level if changed
          if (this.state.map && (this.props.zoom !== this.state.map.getZoom())) {
              this.state.map.setZoom(this.props.zoom);
          }
    }

    handleMapDragEnd() {
        setTimeout(() => {
            const point = this.getCenter();

            this.props.onCenterChange(point.lat, point.lng);
        }, 400);
    }

    handleMapZoomChanged() {
        this.props.onZoomChange(this.state.map.getZoom());
    }

    handleStaticMapClicked = (event) => {
        this.setState({ staticMapSrc: null}, () => this.createDynamicGoogleMap())
    };

    createStaticGoogleMap() {

      let mapElem = document.getElementById("map-container");
      const width = mapElem.offsetWidth;
      const height = mapElem.offsetHeight;
      const zoom = this.props.zoom;
      const lat = this.props.initialCenterLat;
      const lng = this.props.initialCenterLng;
      const scale = 2;

      let mapImageSrc = `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=${zoom}&size=${width}x${height}&scale=${scale}&maptype=roadmap&key=${GOOGLE_MAPS_JS_API_KEY}`;
      this.setState({ staticMapSrc: mapImageSrc, staticMapWidth: width, staticMapHeight: height });
    }

    createDynamicGoogleMap() {
        const styleOptions = {
            name: "FR Style"
        };

        const MAP_STYLE = [
            {
                featureType: "road",
                elementType: "all",
                stylers: [
                    {visibility: "on"}
                ]
            }
        ];

        let mapType = new google.maps.StyledMapType(MAP_STYLE, styleOptions);

        let map = new google.maps.Map(document.getElementById('map-element'), {
            center: {
                lat: this.props.initialCenterLat,
                lng: this.props.initialCenterLng
            },
            zoom: this.props.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            clickableIcons: false,
            zoomControl: false
        });

        map.mapTypes.set("FR Style", mapType);
        map.setMapTypeId("FR Style");
        map.addListener('dragend', this.handleMapDragEnd);
        map.addListener('zoom_changed', this.handleMapZoomChanged);

        this.setState({
            map: map
        })
    }

    getCenter() {
        const center = this.state.map.getCenter();
        return {
            lat: center.lat(),
            lng: center.lng()
        }
    }

    render() {
        return (
            <div id="map-container"
                 style={ styles.container}>
                <div style={ styles.map }
                     id="map-element">
                  {
                    this.state.staticMapSrc &&
                    <div id="static-map">
                      <img
                           onTouchStart={this.handleStaticMapClicked}
                           width={this.state.staticMapWidth}
                           height={this.state.staticMapHeight}
                           style={ { cursor: 'pointer' }}
                           src={this.state.staticMapSrc}/>
                    </div>
                  }

                </div>

                {this.props.children}

                { (this.props.localization.enabled && this.state.map) ?
                    <UserLocationCircle
                        map={this.state.map}
                        lat={this.props.localization.lat}
                        lng={this.props.localization.lng}
                        accuracy={this.props.localization.accuracy}/> : ''}
            </div>
        )
    }
}

const styles = {
    container: {
        position: 'relative',
        height: '100%',
        width: '100%'
    },

    map: {
        height: '100%',
        width: '100%'
    }
};
